import ApiClient from "../apiClient";
import type { DecisionContext } from "../../types/decision-context";

export interface DecisionLayerTelemetryInput {
  contextKey?: string;
  decisionContext?: DecisionContext;
  deskId?: string | null;
  surfaceId: string;
  eventType: string;
  metadata?: Record<string, unknown>;
}

export interface DecisionLayerContextInput {
  contextKey?: string;
  decisionContext: DecisionContext;
}

export interface DecisionLayerWriteResponse {
  ok: boolean;
  contextKey?: string;
  eventKey?: string;
  liveTape?: { written: boolean; reason: string | null };
}

export class DecisionLayerService {
  constructor(private client: ApiClient) {}

  async recordContext(
    input: DecisionLayerContextInput,
  ): Promise<DecisionLayerWriteResponse> {
    return this.client.post("/api/decision-layer/context", input);
  }

  async recordTelemetry(
    input: DecisionLayerTelemetryInput,
  ): Promise<DecisionLayerWriteResponse> {
    return this.client.post("/api/decision-layer/telemetry", input);
  }

  async runMaintenance(): Promise<unknown> {
    return this.client.post("/api/decision-layer/maintenance/run", {});
  }
}
